import type { HelpFile } from '../../types/help'
import { DelegationFormDialogTestIds } from '../../../testids/DelegationFormDialogTestIds'

export const delegationFormDialogHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [DelegationFormDialogTestIds.deputyCombobox]:
      'Search for deputies who will receive your delegated approval authority.',
    [DelegationFormDialogTestIds.selectedDeputies]: null,
    [DelegationFormDialogTestIds.startDateInput]:
      'Date when the delegation becomes active.',
    [DelegationFormDialogTestIds.endDateInput]:
      'Date when the delegation expires — leave empty for a permanent delegation.',
    [DelegationFormDialogTestIds.permanentSwitch]:
      'Make this delegation permanent with no end date.',
    [DelegationFormDialogTestIds.reasonInput]:
      'Optional reason for the delegation — shown to approvers and recorded in the audit log.',
    [DelegationFormDialogTestIds.workflowStepSelect]:
      'Limit the delegation to a specific approval workflow step — leave on default to delegate all approvals.',
  },
}
